import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    // Check if we have a saved end time in localStorage
    let endTime = localStorage.getItem('guitarKitOfferEndTime');
    if (!endTime) {
      // Set end time to 24 hours from now
      const newEndTime = new Date().getTime() + 24 * 60 * 60 * 1000;
      localStorage.setItem('guitarKitOfferEndTime', newEndTime.toString());
      endTime = newEndTime.toString();
    }
    const interval = setInterval(() => {
      const now = new Date().getTime();
      const distance = parseInt(endTime!) - now;
      if (distance < 0) {
        clearInterval(interval);
        setTimeLeft({
          hours: 0,
          minutes: 0,
          seconds: 0
        });
        // Optionally reset timer for demo purposes, but usually it stays at 0
      } else {
        setTimeLeft({
          hours: Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60)),
          minutes: Math.floor(distance % (1000 * 60 * 60) / (1000 * 60)),
          seconds: Math.floor(distance % (1000 * 60) / 1000)
        });
      }
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  return <div className="flex justify-center gap-4 text-center" data-id="element-2">
      <div className="flex flex-col items-center" data-id="element-3">
        <div className="bg-stone-900 text-amber-400 text-4xl md:text-5xl font-black p-4 rounded-lg shadow-inner min-w-[80px]" data-id="element-4">
          {formatNumber(timeLeft.hours)}
        </div>
        <span className="text-xs font-bold mt-2 uppercase tracking-wider text-stone-600" data-id="element-5">
          Horas
        </span>
      </div>
      <div className="text-4xl md:text-5xl font-black text-stone-900 mt-2" data-id="element-6">
        :
      </div>
      <div className="flex flex-col items-center" data-id="element-7">
        <div className="bg-stone-900 text-amber-400 text-4xl md:text-5xl font-black p-4 rounded-lg shadow-inner min-w-[80px]" data-id="element-8">
          {formatNumber(timeLeft.minutes)}
        </div>
        <span className="text-xs font-bold mt-2 uppercase tracking-wider text-stone-600" data-id="element-9">
          Minutos
        </span>
      </div>
      <div className="text-4xl md:text-5xl font-black text-stone-900 mt-2" data-id="element-10">
        :
      </div>
      <div className="flex flex-col items-center" data-id="element-11">
        <div className="bg-stone-900 text-red-500 text-4xl md:text-5xl font-black p-4 rounded-lg shadow-inner min-w-[80px]" data-id="element-12">
          {formatNumber(timeLeft.seconds)}
        </div>
        <span className="text-xs font-bold mt-2 uppercase tracking-wider text-stone-600" data-id="element-13">
          Segundos
        </span>
      </div>
    </div>;
}